"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestPath = void 0;
/**
 * Esta funcion devuelve el path de una request, o el path a la coleccion de requests si no hay assignationId
 * @param type - Tipo de la request. Puede ser analysis, delivery, online o onsite
 * @param assignationId - opcional - AssignationId de la request
 * @returns el path a la coleccion o a los documentos
 */
function getRequestPath(type, assignationId) {
    if (!assignationId)
        return `events/requests/${type}`;
    else
        return `events/requests/${type}/${assignationId}`;
}
exports.getRequestPath = getRequestPath;
